import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';

// API Actions

const UPDATE_MILESTONES_REQUEST =
  'changesync/milestones/UPDATE_MILESTONES_REQUEST';
const UPDATE_MILESTONES_SUCCESS =
  'changesync/milestones/UPDATE_MILESTONES_SUCCESS';
const UPDATE_MILESTONES_FAILURE =
  'changesync/milestones/UPDATE_MILESTONES_FAILURE';

const DELETE_MILESTONES_REQUEST =
  'changesync/milestones/DELETE_MILESTONES_REQUEST';
const DELETE_MILESTONES_SUCCESS =
  'changesync/milestones/DELETE_MILESTONES_SUCCESS';
const DELETE_MILESTONES_FAILURE =
  'changesync/milestones/DELETE_MILESTONES_FAILURE';

// Initial State

const initialState = {
  pending: false,
  success: false,
  error: null,
};

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MILESTONES_REQUEST:
      return {
        ...state,
        pending: true,
        success: false,
        error: null,
      };
    case UPDATE_MILESTONES_SUCCESS:
      return {
        ...state,
        milestoneIds: action.payload.result,
        pending: false,
        success: true,
      };
    case UPDATE_MILESTONES_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case DELETE_MILESTONES_REQUEST:
      return {
        ...state,
        pending: true,
        success: false,
        error: null,
      };
    case DELETE_MILESTONES_SUCCESS:
      return {
        ...state,
        milestoneIds: action.payload.result,
        pending: false,
        success: true,
      };
    case DELETE_MILESTONES_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// Action Creators
export const updateMilestone = (
  milestoneId,
  milestone,
  isDisabledDecamelizeKeys = false,
  isDisabledCamelizeKeys = false
) => {
  return {
    [CALL_API]: {
      endpoint: `milestones/${milestoneId}`,
      method: HTTP_METHODS.PUT,
      types: [
        UPDATE_MILESTONES_REQUEST,
        UPDATE_MILESTONES_SUCCESS,
        UPDATE_MILESTONES_FAILURE,
      ],
      disabledDecamelizeKeys: isDisabledDecamelizeKeys,
      disabledCamelizeKeys: isDisabledCamelizeKeys,
      body: milestone,
    },
  };
};

export const deleteMilestone = (
  milestoneId,
  isDisabledDecamelizeKeys = false,
  isDisabledCamelizeKeys = false
) => {
  return {
    [CALL_API]: {
      endpoint: `milestones/${milestoneId}`,
      method: HTTP_METHODS.DELETE,
      types: [
        DELETE_MILESTONES_REQUEST,
        DELETE_MILESTONES_SUCCESS,
        DELETE_MILESTONES_FAILURE,
      ],
      disabledDecamelizeKeys: isDisabledDecamelizeKeys,
      disabledCamelizeKeys: isDisabledCamelizeKeys,
    },
  };
};
